<div
	class="jepto-ai-credits-incentives-panel__card"
	[class.jepto-ai-credits-incentives-panel__card--expanded]="isExpanded()"
	[attr.data-testid]="resolvedTestId()"
>
	<div class="jepto-ai-credits-incentives-panel__header">
		<button
			type="button"
			class="jepto-ai-credits-incentives-panel__toggle"
			[attr.aria-expanded]="isExpanded()"
			[attr.data-testid]="resolvedTestId() + '-toggle'"
			(click)="toggleExpanded()"
		>
			<span class="jepto-ai-credits-incentives-panel__toggle-text">
				@if (variant() === 'topbar') {
					<img
						class="jepto-ai-credits-incentives-panel__mark"
						ngSrc="assets/images/star.svg"
						width="24"
						height="24"
						alt=""
					/>
					<span class="jepto-ai-credits-incentives-panel__copy">
						<span class="jepto-ai-credits-incentives-panel__title">
							Get extra AI credits
						</span>
						<span
							class="jepto-ai-credits-incentives-panel__summary"
							[attr.data-testid]="resolvedTestId() + '-summary'"
						>
							{{ availableCreditsSummary() }}
							<span
								class="jepto-ai-credits-incentives-panel__route"
							>
								View
								<i
									class="icon"
									[class.icon-chevron-down]="!isExpanded()"
									[class.icon-chevron-up]="isExpanded()"
									aria-hidden="true"
								></i>
							</span>
						</span>
					</span>
				} @else {
					<span class="jepto-ai-credits-incentives-panel__title">
						Get Free AI Credits
					</span>
					@if (!isExpanded()) {
						<span
							class="jepto-ai-credits-incentives-panel__summary"
							[attr.data-testid]="resolvedTestId() + '-summary'"
						>
							{{ availableCreditsSummary() }}
						</span>
					}
				}
			</span>
			@if (variant() !== 'topbar') {
				<span
					class="jepto-ai-credits-incentives-panel__chevron icon"
					[class.icon-chevron-down]="!isExpanded()"
					[class.icon-chevron-up]="isExpanded()"
					aria-hidden="true"
				></span>
			}
		</button>
		<button
			type="button"
			class="jepto-ai-credits-incentives-panel__dismiss"
			[attr.data-testid]="resolvedTestId() + '-dismiss'"
			aria-label="Dismiss extra AI credits"
			title="Dismiss"
			(click)="onDismiss($event)"
		>
			<span class="icon icon-close" aria-hidden="true"></span>
		</button>
	</div>

	@if (isExpanded()) {
		<div class="jepto-ai-credits-incentives-panel__popover">
			<ul class="jepto-ai-credits-incentives-panel__list">
			@for (row of incentiveRows(); track row.item.id) {
				<li class="jepto-ai-credits-incentives-panel__item">
					<button
						type="button"
						class="jepto-ai-credits-incentives-panel__item-button"
						[class.jepto-ai-credits-incentives-panel__item-button--completed]="
							row.completed
						"
						[class.jepto-ai-credits-incentives-panel__item-button--pending]="
							row.pending
						"
						[disabled]="!row.actionable"
						[attr.data-testid]="
							resolvedTestId() + '-item-' + row.item.id
						"
						(click)="onIncentiveClick(row.item, $event)"
					>
						<span
							class="jepto-ai-credits-incentives-panel__item-title"
						>
							@if (row.completed) {
								<span
									class="jepto-ai-credits-incentives-panel__item-check icon-check"
									aria-hidden="true"
								></span>
							}
							{{ row.item.title }}
						</span>
						<span
							class="jepto-ai-credits-incentives-panel__item-reward"
							[attr.data-testid]="
								resolvedTestId() +
								'-item-' +
								row.item.id +
								'-reward'
							"
						>
							{{ row.reward }}
						</span>
					</button>
				</li>
			}
			</ul>

			@if (isLoading()) {
				<p
					class="jepto-ai-credits-incentives-panel__loading"
					[attr.data-testid]="resolvedTestId() + '-loading'"
				>
					Loading incentives…
				</p>
			}

			@if (variant() === 'topbar') {
				<button
					type="button"
					class="jepto-ai-credits-incentives-panel__usage-hint"
					[attr.data-testid]="resolvedTestId() + '-help'"
					(click)="openAiCreditsHelp($event)"
				>
					What can I do with AI credits?
				</button>
			}
		</div>
	}
</div>

@if (variant() === 'topbar') {
	<jep-drawer
		[id]="helpDrawerId"
		mode="small"
		breadcrumb=""
		[title]="' '"
		[attr.data-test]="helpDrawerId"
	>
		<jepto-help-article
			[title]="helpTitle"
			[size]="'small'"
			[content]="helpContent"
			[relatedArticles]="relatedArticles"
			[relatedArticlesLabel]="'Learn more:'"
			(close)="closeAiCreditsHelp()"
		></jepto-help-article>
	</jep-drawer>
}
